import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

import { Aggregation } from '@models/feature-descriptor';

export const AggregationTypeSelector = (props: {
  selectedType: Aggregation.Type;
  onTypeChange: (type: Aggregation.Type) => void;
  onBlur?: () => void;
}) => {
  const options = Object.values(Aggregation.Type);
  return (
    <Autocomplete
      options={options}
      value={props.selectedType}
      size="small"
      autoComplete
      disableClearable
      blurOnSelect
      openOnFocus
      forcePopupIcon={false}
      onBlur={props.onBlur}
      onChange={(e, value) => value && props.onTypeChange(value)}
      renderInput={params => (
        <TextField {...params} variant="standard" autoFocus={true} />
      )}
    />
  );
};
